import { gql } from "@apollo/client";

const ADD_USER_SPORT = gql`
  mutation createUserSport($user: Int!, $sport: Int!, $team: String) {
    createUserSport(createUserSportInput: { user: $user, sport: $sport, team: $team }) {
      id
    }
  }
`;
export default ADD_USER_SPORT;
